/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { FlexLayout, FlexItem, Button } from '@waca/ca-ui-toolkit';
import stringResource from 'ba-filter-nls';

import './FilterFooter.scss';

export default class FilterFooter extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		onClear: PropTypes.func,
		onApply: PropTypes.func,
		onOk: PropTypes.func,
		onCancel: PropTypes.func,
		loading: PropTypes.bool,
		readOnly: PropTypes.bool,
		showApply: PropTypes.bool,
		dirty: PropTypes.bool,
	};

	static defaultProps = {
		loading: false,
		readOnly: false,
		showApply: false,
		dirty: false,
	};

	_onApply = () => {
		if (this.props.onApply !== undefined) {
			this.props.onApply();
		}
	};

	_onOk = () => {
		if (this.props.onOk !== undefined) {
			this.props.onOk();
		}
	};

	_onCancel = () => {
		if (this.props.onCancel !== undefined) {
			this.props.onCancel();
		}
	};

	_onClear = () => {
		if (this.props.onClear !== undefined) {
			this.props.onClear();
		}
	};

	_renderApply = () => {
		const { loading, readOnly, dirty } = this.props;

		return (
			<FlexLayout alignItems="center" direction="row">
				<FlexItem textAlign="left" grow>
					<Button
						data-tid="clearAllClickable"
						intent="primary"
						variant="inline"
						label={stringResource.get('clearAll')}
						onClick={this._onClear}
						disabled={loading || readOnly}
					/>
				</FlexItem>
				<FlexItem>
					<Button
						data-tid="applyClickable"
						intent={dirty ? 'primary' : 'secondary'}
						label={stringResource.get('apply')}
						onClick={this._onApply}
						disabled={loading || readOnly || !dirty}
					/>
				</FlexItem>
			</FlexLayout>
		);
	};

	_renderOk = () => {
		const { loading, readOnly, dirty } = this.props;

		return (
			<div className="bi-common-filter-footer">
				<FlexLayout alignItems="center" direction="row" justifyContent="flex-end">
					<FlexItem gutter={[0, 2, 0, 0]}>
						<Button
							data-tid="okClickable"
							intent={dirty ? 'primary' : 'secondary'}
							label={stringResource.get('ok')}
							title={stringResource.get('ok')}
							aria-label={stringResource.get('ok')}
							onClick={this._onOk}
							disabled={loading || readOnly || !dirty}
						/>
					</FlexItem>
					<FlexItem>
						<Button
							data-tid="cancelClickable"
							intent="secondary"
							label={stringResource.get('cancel')}
							title={stringResource.get('cancel')}
							aria-label={stringResource.get('cancel')}
							onClick={this._onCancel}
							disabled={loading || readOnly}
						/>
					</FlexItem>
				</FlexLayout>
			</div>
		);
	};

	render() {
		if (this.props.showApply) {
			return this._renderApply();
		}

		return this._renderOk();
	}
}
